import { useEffect, useState } from "react";

const STORAGE_KEY = "darkMode";

const readStoredTheme = (): boolean => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) === true : false;
    } catch {
        return false;
    }
};

/**
 * Light / dark preference. Same storage key and `body.dark` class the old
 * react-toggle switch used, so existing users keep their choice.
 */
export const useThemePreference = () => {
    const [isDark, setIsDark] = useState<boolean>(readStoredTheme);

    useEffect(() => {
        document.body.classList.toggle("dark", isDark);
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(isDark));
        } catch {
            // private mode / blocked storage: the class still applies for this tab
        }
    }, [isDark]);

    return { isDark, setIsDark };
};
